import { getSafariMajorVersion, iOS, iOSversion } from "../ulti";

export class WebShareController {
  deviceCanShare():boolean {
    return !!(navigator as any).share;
  }

  deviceCanShareFile():boolean {
    const nav = navigator as any;

    // Create sample file to test file share feature.
    const data = new Uint8Array(64);
    for (let i = 0; i < 64; i++) {
      data[i] = i;
    }
    const blob = new Blob([data], {type:"image/png"});
    const file = new File([blob], "foo.png", {type:"image/png"});

    const safariMajorVersion = getSafariMajorVersion();

    if (safariMajorVersion !== undefined && safariMajorVersion < 15) {
      // detected Safari (or Chrome & Fire Fox via Safari WebKit)
      // these browsers don't yet support Web Share level 2
      // which we need to share the image.
      return false;
    }

    return !!nav.canShare && nav.canShare({
      title: 'sample title',
      text: 'sample text',
      url: 'https://www.google.de/',
      files: [ file ]
    });
  }

  share(title:string, text:string, url:string, image?:Blob):void {
    const data:ShareData = {
      title: title,
      text: text,
      url: url
    };
    if (image) {
      const file = new File([image], "screenshot.png", {type:"image/jpeg"});
      data["files"] = [ file ];
    }
    navigator.share(data);
  }
}